define('app/views/modal_view',['app/setup'], function(takhfifan) {
  takhfifan.modalView = Backbone.View.extend({
    initialize: function() {
      this.close_on_modal_click = true;
      this.disable_trigger_element_on_close = false;
      this.triggerElement = null;
      var _this = this;
      var modalWrapper = $(".tkh-modal");
      $(".tkh-modal-toggle").on("click",function(){
        var thisID = $(this).attr("data-target");
        $(".tkh-modal-overlay").fadeIn(400);
        if($(this).hasClass('no-close')){
          $(".tkh-modal-overlay").addClass('no-close');
        }
        $("#" + thisID).fadeIn(300);
      });
      $(".tkh-modal").on("click",function(){
        if(_this.close_on_modal_click) {
          $(modalWrapper).fadeOut(300);
          $(this).fadeOut(300);
          $(".tkh-modal-overlay").fadeOut(300);
        }
      });
      $(".tkh-modal-icon-close, .tkh-modal-close-modal, .tkh-modal-overlay").on("click",function(){
        //this.$('#allow_gift_messages').prop('checked', true);
        _this.closeModalWithContent();
      });
      takhfifan.eventHub.on('modal:showWithTimeout', function(options) {
        _this.showAndTimeout(options);
      }, this);
      takhfifan.eventHub.on('modal:showModalWithContent', function(options) {
        _this.showModalWithContent(options);
      }, this);
      takhfifan.eventHub.on('modal:closeModalWithContent', function(options) {
        _this.closeModalWithContent();
      }, this);
      takhfifan.eventHub.on('modal:showModal', function(options) {
        _this.showModal(options);
      }, this);
    },
    showAndTimeout: function(options) {
      $(".tkh-modal-overlay").addClass('no-close').fadeIn(options.fadeTimeIn).delay(options.timeOut).fadeOut(options.fadeTimeOut, function() {$(".tkh-modal-overlay").addClass('no-close')});
      options.elementToOperate.fadeIn(options.fadeTimeIn).delay(options.timeOut).fadeOut(options.fadeTimeOut);
    },
    showModalWithContent: function(options) {
      this.close_on_modal_click = false;
      this.disable_trigger_element_on_close = true;
      $(".tkh-modal-overlay").fadeIn(options.fadeTimeIn);
      options.elementToOperate.fadeIn(options.fadeTimeIn).find('.modal-content').html(options.elementToOperateContent);
      this.triggerElement = options.triggerElement;
      takhfifan.eventHub.trigger('modal:modelWithContentShown',options);
    },
    closeModalWithContent: function() {
      var modalWrapper = $(".tkh-modal");
      var _this = this;
      $(modalWrapper).fadeOut(300);
        $(".tkh-modal-overlay").fadeOut(300, function() {
          $(".tkh-modal-overlay").removeClass('no-close')
        });
        if(_this.disable_trigger_element_on_close && _this.triggerElement) {
          takhfifan.eventHub.trigger('modal:disableTriggerElement',
          {triggerElement:_this.triggerElement});
        }
    },
    showModal: function(options) {
      this.close_on_modal_click = false;
      this.disable_trigger_element_on_close = true;
      $(".tkh-modal-overlay").fadeIn(options.fadeTimeIn);
      options.elementToOperate.fadeIn(options.fadeTimeIn);
      this.triggerElement = options.triggerElement;
      takhfifan.eventHub.trigger('modal:modelWithContentShown',options);
    }
  });
});

